/**
 * Shared formatting and value-check utilities used across device-related components.
 */

/** Format an ISO date string into ja-JP locale (yyyy/MM/dd HH:mm:ss). Returns '-' for null. */
export function formatDateTime(dateStr: string | null): string {
  if (!dateStr) return '-'
  const date = new Date(dateStr)
  return new Intl.DateTimeFormat('ja-JP', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).format(date)
}

/** Check if a string value is non-null, non-undefined, and non-empty. */
export function hasValidValue(value: string | null | undefined): boolean {
  return value !== null && value !== undefined && value !== ''
}
